import styled from 'styled-components';

export const Image = styled.img`
  width: 115px;
  height: 90px;
  border-radius: 6px;
  object-fit: cover;
`;
export const Flex = styled.div`
  display: flex;
  padding: ${(props) => (props.topicNew ? '0' : '4px 0 12px')} 4px 0 12px;
  margin-left: ${(props) => props.marginLeft};
`;

export const CategoryTitle = styled.p`
  font-weight: 600;
  padding: 4px 6px 0 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

export const CategoryAns = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 6px 12px 0 0;
  max-width: ${(props) => (props.maxW ? props.maxW : '100%')};
  & img {
    display: none;
  }
  & h3,
  h2 {
    display: none;
  }
`;
